module.exports = "/_next/static/images/MaximizeReturn@2x-b3a09a655f3b4b48263c7628d074fd8f.webp";